import React, { useContext, useEffect } from 'react';
import { AppSettings } from './../../config/app-settings.js';


function ExtraSettingsPage() {
	const context = useContext(AppSettings);

	useEffect(() => {
		context.handleSetAppSidebarMinified(true);

		const sections = document.querySelectorAll('#bsSpyContent > div');
		const navLinks = document.querySelectorAll('#bsSpyTarget > a');
		const activateNavLink = (id) => navLinks.forEach((link) => link.classList.toggle('active', link.getAttribute('href') === `#${id}`));
		const handleViewport = () => {
			let activeSection = sections[0]?.id;
			sections.forEach((section) => { if (section.getBoundingClientRect().top <= window.innerHeight * 0.35) activeSection = section.id; });
			if (activeSection) activateNavLink(activeSection);
		};
		const handleNavClick = (event) => {
			const target = document.querySelector(event.currentTarget.getAttribute('href'));
			if (!target) return;
			event.preventDefault();
			target.scrollIntoView({ behavior: 'smooth', block: 'start' });
		};
		navLinks.forEach((link) => link.addEventListener('click', handleNavClick));
		window.addEventListener('scroll', handleViewport);
		handleViewport();
		return () => {
			navLinks.forEach((link) => link.removeEventListener('click', handleNavClick));
			window.removeEventListener('scroll', handleViewport);
			context.handleSetAppSidebarMinified(false);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return (
		<>
			
						
						<h1 className="page-header">Settings Page <small>page header description goes here...</small></h1>
						
						<hr className="mb-4" />
						
						
						<div className="row">
							
							<div style={{ width: "230px" }}>
								
								<nav className="navbar navbar-sticky navbar-sticky-end d-none d-xl-block my-n4 py-4 h-100 text-end">
									<nav className="nav" id="bsSpyTarget">
										<a className="nav-link active" href="#general" data-toggle="scroll-to">General</a>
										<a className="nav-link" href="#notifications" data-toggle="scroll-to">Notifications</a>
										<a className="nav-link" href="#privacyAndSecurity" data-toggle="scroll-to">Privacy and security</a>
										<a className="nav-link" href="#payment" data-toggle="scroll-to">Payment</a>
										<a className="nav-link" href="#shipping" data-toggle="scroll-to">Shipping</a>
										<a className="nav-link" href="#mediaAndFiles" data-toggle="scroll-to">Media and Files</a>
										<a className="nav-link" href="#languages" data-toggle="scroll-to">Languages</a>
										<a className="nav-link" href="#system" data-toggle="scroll-to">System</a>
										<a className="nav-link" href="#resetSettings" data-toggle="scroll-to">Reset settings</a>
									</nav>
								</nav>
								
							</div>
							
							
							<div className="col-xl-8" id="bsSpyContent">
								
								<div id="general" className="mb-4 pb-3">
									<h4 className="d-flex align-items-center mb-2">
										<iconify-icon className="fs-24px me-2 text-body text-opacity-75 my-n1" icon="solar:user-bold-duotone"></iconify-icon> General
									</h4>
									<p>View and update your general account information and settings.</p>
									<div className="card">
										<div className="list-group list-group-flush fw-semibold">
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">Name</div>
													<div className="text-body text-opacity-60">Sean Ngu</div>
												</div>
												<div className="w-100px">
													<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-secondary w-100px">Edit</a>
												</div>
											</div>
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">Username</div>
													<div className="text-body text-opacity-60">@seantheme</div>
												</div>
												<div>
													<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-secondary w-100px">Edit</a>
												</div>
											</div>
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">Phone</div>
													<div className="text-body text-opacity-60">+1-202-555-0183</div>
												</div>
												<div>
													<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-secondary w-100px">Edit</a>
												</div>
											</div>
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">Email address</div>
													<div className="text-body text-opacity-60">support@seantheme.com</div>
												</div>
												<div>
													<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-secondary disabled w-100px">Edit</a>
												</div>
											</div>
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">Password</div>
												</div>
												<div>
													<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-secondary w-100px">Edit</a>
												</div>
											</div>
										</div>
									</div>
								</div>
								
							
								
								<div id="notifications" className="mb-4 pb-3">
									<h4 className="d-flex align-items-center mb-2 mt-3">
										<iconify-icon className="fs-24px me-2 text-body text-opacity-75 my-n1" icon="solar:bell-bold-duotone"></iconify-icon> 
										Notifications
									</h4>
									<p>Enable or disable what notifications you want to receive.</p>
									<div className="card">
										<div className="list-group list-group-flush fw-semibold">
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">Comments</div>
													<div className="text-body text-opacity-60 d-flex align-items-center">
														<i className="fa fa-circle fs-6px mt-1px fa-fw text-success me-2"></i> Enabled (Push, SMS)
													</div>
												</div>
												<div>
													<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-secondary w-100px">Edit</a>
												</div>
											</div>
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">Tags</div>
													<div className="text-body text-opacity-60 d-flex align-items-center">
														<i className="fa fa-circle fs-6px mt-1px fa-fw text-body text-opacity-25 me-2"></i> Disabled
													</div>
												</div>
												<div>
													<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-secondary w-100px">Edit</a>
												</div>
											</div>
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">Reminders</div>
													<div className="text-body text-opacity-60 d-flex align-items-center">
														<i className="fa fa-circle fs-6px mt-1px fa-fw text-success me-2"></i> Enabled (Push, Email, SMS)
													</div>
												</div>
												<div>
													<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-secondary w-100px">Edit</a>
												</div>
											</div>
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">New orders</div>
													<div className="text-body text-opacity-60 d-flex align-items-center">
														<i className="fa fa-circle fs-6px mt-1px fa-fw text-success me-2"></i> Enabled (Push, Email, SMS)
													</div>
												</div>
												<div>
													<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-secondary w-100px">Edit</a>
												</div>
											</div>
										</div>
									</div>
								</div>
								
							
								
								<div id="privacyAndSecurity" className="mb-4 pb-3">
									<h4 className="d-flex align-items-center mb-2 mt-3">
										<iconify-icon className="fs-24px me-2 text-body text-opacity-75 my-n1" icon="solar:lock-password-bold-duotone"></iconify-icon> 
										Privacy and security
									</h4>
									<p>Limit the account visibility and the security settings for your website.</p>
									<div className="card">
										<div className="list-group list-group-flush fw-semibold">
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">Who can see your future posts?</div>
													<div className="text-body text-opacity-60 d-flex align-items-center">
														Friends only
													</div>
												</div>
												<div>
													<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-secondary w-100px">Edit</a>
												</div>
											</div>
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">Photo tagging</div>
													<div className="text-body text-opacity-60 d-flex align-items-center">
														<i className="fa fa-circle fs-6px mt-1px fa-fw text-success me-2"></i> Enabled
													</div>
												</div>
												<div>
													<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-secondary w-100px">Edit</a>
												</div>
											</div>
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">Location information</div>
													<div className="text-body text-opacity-60 d-flex align-items-center">
														<i className="fa fa-circle fs-6px mt-1px fa-fw text-body text-opacity-25 me-2"></i> Disabled
													</div>
												</div>
												<div>
													<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-secondary w-100px">Edit</a>
												</div>
											</div>
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">Firewall</div>
													<div className="text-body text-opacity-60 d-block d-xl-flex align-items-center">
														<div className="d-flex align-items-center"><i className="fa fa-circle fs-6px mt-1px fa-fw text-body text-opacity-25 me-2"></i> Disabled</div>
														<span className="bg-warning bg-opacity-10 text-warning ms-xl-3 mt-1 d-inline-block mt-xl-0 px-1 rounded-sm">
															<i className="fa fa-exclamation-circle text-warning fs-12px me-1"></i> 
															<span className="text-warning">Please enable the firewall for your website</span>
														</span>
													</div>
												</div>
												<div>
													<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-secondary w-100px">Edit</a>
												</div>
											</div>
										</div>
									</div>
								</div>
								
							
								
								<div id="payment" className="mb-4 pb-3">
									<h4 className="d-flex align-items-center mb-2 mt-3">
										<iconify-icon className="fs-24px me-2 text-body text-opacity-75 my-n1" icon="solar:bag-4-bold-duotone"></iconify-icon> 
										Payment
									</h4>
									<p>Manage your website payment provider</p>
									<div className="card">
										<div className="list-group list-group-flush fw-semibold">
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">Allowed payment method</div>
													<div className="text-body text-opacity-60">
														Paypal, Credit Card, Apple Pay, Amazon Pay, Google Wallet, Alipay, Wechatpay
													</div>
												</div>
												<div>
													<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-secondary w-100px">Edit</a>
												</div>
											</div>
										</div>
									</div>
								</div>
								
							
								
								<div id="shipping" className="mb-4 pb-3">
									<h4 className="d-flex align-items-center mb-2 mt-3">
										<iconify-icon className="fs-24px me-2 text-body text-opacity-75 my-n1" icon="solar:box-bold-duotone"></iconify-icon> 
										Shipping
									</h4>
									<p>Allowed shipping area and zone setting</p>
									<div className="card">
										<div className="list-group list-group-flush fw-semibold">
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">Allowed shipping method</div>
													<div className="text-body text-opacity-60">
														Local, Domestic
													</div>
												</div>
												<div>
													<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-secondary w-100px">Edit</a>
												</div>
											</div>
										</div>
									</div>
								</div>
								
							
								
								<div id="mediaAndFiles" className="mb-4 pb-3">
									<h4 className="d-flex align-items-center mb-2 mt-3">
										<iconify-icon className="fs-24px me-2 text-body text-opacity-75 my-n1" icon="solar:camera-bold-duotone"></iconify-icon> 
										Media and Files
									</h4>
									<p>Allowed files and media format upload setting</p>
									<div className="card">
										<div className="list-group list-group-flush fw-semibold">
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">Allowed files and media format</div>
													<div className="text-body text-opacity-60">
														.png, .jpg, .gif, .mp4
													</div>
												</div>
												<div>
													<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-secondary w-100px">Edit</a>
												</div>
											</div>
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">Media and files cdn</div>
													<div className="text-body text-opacity-60 d-flex align-items-center">
														<i className="fa fa-circle fs-6px mt-1px fa-fw text-body text-opacity-25 me-2"></i> Disabled
													</div>
												</div>
												<div>
													<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-secondary w-100px">Edit</a>
												</div>
											</div>
										</div>
									</div>
								</div>
								
							
								
								<div id="languages" className="mb-4 pb-3">
									<h4 className="d-flex align-items-center mb-2 mt-3">
										<iconify-icon className="fs-24px me-2 text-body text-opacity-75 my-n1" icon="solar:globus-bold-duotone"></iconify-icon> 
										Languages
									</h4>
									<p>Language font support and auto translation enabled</p>
									<div className="card">
										<div className="list-group list-group-flush fw-semibold">
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">Language enabled</div>
													<div className="text-body text-opacity-60">
														English (default), Chinese, France, Portuguese, Japense
													</div>
												</div>
												<div>
													<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-secondary w-100px">Edit</a>
												</div>
											</div>
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">Auto translation</div>
													<div className="text-body text-opacity-60 d-flex align-items-center">
														<i className="fa fa-circle fs-6px mt-1px fa-fw text-success me-2"></i> Enabled
													</div>
												</div>
												<div>
													<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-secondary w-100px">Edit</a>
												</div>
											</div>
										</div>
									</div>
								</div>
								
							
								
								<div id="system" className="mb-4 pb-3">
									<h4 className="d-flex align-items-center mb-2 mt-3">
										<iconify-icon className="fs-24px me-2 text-body text-opacity-75 my-n1" icon="solar:ssd-round-bold-duotone"></iconify-icon> 
										System
									</h4>
									<p>System storage, bandwidth and database setting</p>
									<div className="card">
										<div className="list-group list-group-flush fw-semibold">
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">Web storage</div>
													<div className="text-body text-opacity-60">
														40.8gb / 100gb
													</div>
												</div>
												<div>
													<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-secondary w-100px">Manage</a>
												</div>
											</div>
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">Monthly bandwidth</div>
													<div className="text-body text-opacity-60">
														Unlimited
													</div>
												</div>
											</div>
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">Database</div>
													<div className="text-body text-opacity-60">
														MySQL version 8.0.19
													</div>
												</div>
												<div>
													<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-secondary w-100px disabled">Update</a>
												</div>
											</div>
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div className="fw-bold">Platform</div>
													<div className="text-body text-opacity-60">
														PHP 7.4.4, NGINX 1.17.0
													</div>
												</div>
												<div>
													<a href="#modalEdit" data-bs-toggle="modal" className="btn btn-success w-100px">Update</a>
												</div>
											</div>
										</div>
									</div>
								</div>
								
							
								
								<div id="resetSettings" className="mb-4 pb-3">
									<h4 className="d-flex align-items-center mb-2 mt-3">
										<iconify-icon className="fs-24px me-2 text-body text-opacity-75 my-n1" icon="solar:restart-bold-duotone"></iconify-icon> 
										Reset settings
									</h4>
									<p>Reset all website setting to factory default setting.</p>
									<div className="card">
										<div className="list-group list-group-flush fw-bold">
											<div className="list-group-item d-flex align-items-center">
												<div className="flex-fill">
													<div>Reset Settings</div>
													<div className="text-body text-opacity-60">
														This action will clear and reset all the current website setting.
													</div>
												</div>
												<div>
													<a href="#/" className="btn btn-secondary w-100px">Reset</a>
												</div>
											</div>
										</div>
									</div>
								</div>
								
							</div>
							
						</div>
						
					
		<div className="modal fade" id="modalEdit" tabIndex="-1" aria-labelledby="modalEditLabel" aria-hidden="true">
			<div className="modal-dialog">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title" id="modalEditLabel">Edit name</h5>
						<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div className="modal-body">
						<div className="mb-3">
							<label className="form-label" htmlFor="settingsFirstName">Name</label>
							<div className="row">
								<div className="col-4"><input id="settingsFirstName" className="form-control" placeholder="First" defaultValue="Sean" /></div>
								<div className="col-4"><input className="form-control" placeholder="Middle" defaultValue="" /></div>
								<div className="col-4"><input className="form-control" placeholder="Last" defaultValue="Ngu" /></div>
							</div>
						</div>
						<div className="alert bg-body">
							<b>Please note:</b> If you change your name, you can't change it again for 60 days. Don't add any unusual capitalization, punctuation, characters or random words. <a href="#/" className="alert-link">Learn more.</a>
						</div>
						<div className="mb-3">
							<label className="form-label">Other Names</label>
							<div><button type="button" className="btn btn-secondary"><i className="fa fa-plus fa-fw"></i> Add other names</button></div>
						</div>
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-default" data-bs-dismiss="modal">Close</button>
						<button type="button" className="btn btn-theme" data-bs-dismiss="modal">Save changes</button>
					</div>
				</div>
			</div>
		</div>
		</>
	);
}

export default ExtraSettingsPage;
